export default __webpack_public_path__ + "static/media/ic_benin.aa0c7cdb.svg";